module.exports = __webpack_public_path__ + "media/images/mobile/hamburguer-97f20bd961ff9204adf5f84e5a4a7153.png";